import { Box, Typography } from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import CluppDropdown from "../../../Components/CluppForms/CluppDropdown";

const BenefitsClupp = ({ state, setState }) => {
  return (
    <>
      <TitleHeaders
        title={"Beneficios que te encantan de Clupp"}
        subtitle={""}
      />
      <Box>
        <CluppDropdown
          title={"Expediente digital"}
          startIcon={<Typography sx={{ fontSize: "20px" }}>🚗</Typography>}
          description={
            <>
              <strong>
                Puedes agregar y organizar fácilmente todos los registros
                importantes de tu vehículo{" "}
                <span role="img" aria-label="star-eyes">
                  ✨
                </span>
                :
              </strong>
              <br />
              Ya sea el cambio de llantas, servicios, visitas al taller o
              incluso cuando le echaste gasolina, tendrás todo bajo control y a
              tu alcance. ¡Así nunca te olvidarás de nada importante!
            </>
          }
        />
        <CluppDropdown
          title={"Cupones por conducir bien"}
          startIcon={<Typography sx={{ fontSize: "20px" }}>🎟</Typography>}
          description={
            <>
              Te damos beneficios geniales. Puedes abonar hasta $200 pesos en tu
              próximo cobro del seguro, conseguir boletos de cine por solo $19
              pesos o incluso boletos gratis. ¡Tu buen manejo tiene sus
              recompensas!
            </>
          }
        />
        <CluppDropdown
          title={"Avisos importantes"}
          startIcon={<Typography sx={{ fontSize: "20px" }}>📢</Typography>}
          description={
            <>
              <strong>Avisos importantes:</strong> La app te mantiene al tanto
              con avisos importantes como “Hoy No Circula” y las fechas de
              verificación. Así, siempre estarás informado y evitarás cualquier
              inconveniente. ¡Todo desde la comodidad de tu celular!
            </>
          }
        />
        <CluppDropdown
          title={"Somos el único seguro que no sube su prima"}
          startIcon={<Typography sx={{ fontSize: "20px" }}>🛡</Typography>}
          description={
            <>
              <strong>Somos el único seguro que no sube su prima:</strong>{" "}
              Siempre y cuando no canceles. ¡Y eso incluye todos los pagos,
              excepto los que son a meses sin intereses! Así, puedes estar
              tranquilo sabiendo que tu prima se mantendrá igual.
            </>
          }
        />
      </Box>
    </>
  );
};

export default BenefitsClupp;
